/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { isEmpty } from "lodash";
import { END } from "redux-saga";
import { wrapper } from "../../../../app/store";
import Layout from "../../../../components/features/Default/layout/layout";
import PracticeDetail from "../../../../components/features/topics/pages/PracticeDetail";
import { ACTION_TYPES } from "../../../../components/features/topics/redux/actionTypes";
import { ACTION_TYPES as ACTION_TYPES_COMMON } from "../../../../components/features/common/redux/actionTypes";
import { getTimeServer } from "../../../../components/features/common/utils/commonAPI";
import { getPracticeDetailSSR } from "../../../api/quiz";

// eslint-disable-next-line no-unused-vars
export const getServerSideProps: any = wrapper.getServerSideProps((store) => async ({ query, resolvedUrl }) => {
  const { grade, subjectsId, topicId }: any = query;
  const handleGetPracticeDetail = async () => {
    if (!isEmpty(topicId) && topicId?.includes(grade)) {
      store.dispatch({ type: ACTION_TYPES.GET_PRACTICE_DETAIL });
      Promise.all([
        await getTimeServer().then((res) =>
          store.dispatch({
            type: ACTION_TYPES_COMMON.GET_TIME_SERVER_SUCCESS,
            params: res?.data
          })
        ),
        await getPracticeDetailSSR(store, { topicId })
          .then((res: any) =>
            store.dispatch({ type: ACTION_TYPES.GET_PRACTICE_DETAIL_SUCCESS, params: res?.data?.data })
          )
          .catch((err) => {
            store.dispatch({ type: ACTION_TYPES.GET_PRACTICE_DETAIL_FAILED, params: err?.data?.error || err });
          })
      ]);
    }
  };
  await handleGetPracticeDetail();

  // end the saga
  store.dispatch(END);
  await store?.sagaTask.toPromise();

  return {
    props: {
      grade,
      subjectsId,
      topicId,
      practice: store?.getState()?.quizCore?.practice
    }
  };
});

export default function PracticeDetailPage(props) {
  const { practice } = props;
  return (
    <Layout
      pageProps={{
        title: practice?.seo_data?.meta_title || practice?.title,
        description: practice?.seo_data?.meta_desc,
        ogTitle: practice?.seo_data?.meta_og_title,
        ogDescription: practice?.seo_data?.meta_og_desc,
        imageUrl: practice?.seo_data?.meta_og_image
      }}
    >
      <PracticeDetail props={props} />
    </Layout>
  );
}
